/**
 * Day and night on the map.
 *
 * Darkness is a function of the sun's altitude below the horizon, in the three
 * bands astronomers use: civil twilight to −6°, when it is still light enough
 * to read outdoors; nautical to −12°, when the horizon fades; astronomical to
 * −18°, after which it is fully night. The map shades each band a step darker,
 * so the terminator is a soft graded edge, as it looks from orbit.
 */

const D = Math.PI / 180;

/** Opacity of the night shade, 0 in daylight .. 0.6 in full night. */
export function nightShade(sunAltitude: number): number {
  const a = sunAltitude / D;
  if (a >= 0) return 0;
  if (a >= -6) return (-a / 6) * 0.28;
  if (a >= -12) return 0.28 + ((-a - 6) / 6) * 0.14;
  if (a >= -18) return 0.42 + ((-a - 12) / 6) * 0.1;
  return 0.52 + Math.min(0.08, (-a - 18) / 60);
}

export function twilightName(sunAltitude: number): string {
  const a = sunAltitude / D;
  if (a > -0.833) return 'day';
  if (a > -6) return 'civil twilight';
  if (a > -12) return 'nautical twilight';
  if (a > -18) return 'astronomical twilight';
  return 'night';
}
